// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"71949de5","31":"a2504d07","141":"659ab09b","341":"eac3e386","392":"36adf198","405":"cf131a93","495":"633410e7","533":"c0e4b2b8","543":"ee03a21e","630":"bd1d2983","787":"ea62b73b","874":"56da02e9","945":"156acf11"}[chunkId] + ".chunk.js";
};